import { useEffect, useRef } from "react";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
export function useChatBot() {
  var intervalRef = useRef(null);
  useEffect(function () {
    if (!checkFeatureFlag("FF_CHAT_BOT")) {
      return;
    }
    var showChatWidget = function showChatWidget() {
      var element = document.getElementById("pingpongchat");
      if (element) {
        element.style.display = "flex";
      }
    };
    var checkFcDnClass = function checkFcDnClass() {
      var fcElement = document.querySelector("#fc_frame");
      if (fcElement && fcElement.classList.length > 1) {
        showChatWidget();
        clearInterval(intervalRef.current);
        return true;
      }
      return false;
    };
    var script = document.createElement("script");
    script.innerHTML = "\n      window.fcWidgetMessengerConfig = {\n        config: {\n          headerProperty: {\n            hideChatButton: true,\n          },\n        },\n      };\n    ";
    document.head.appendChild(script);
    var chatScript = document.createElement("script");
    chatScript.src = "https://uae.fw-cdn.com/40037110/10275.js";
    chatScript.async = true;
    chatScript.onload = function () {
      intervalRef.current = setInterval(function () {
        var fcFrame = document.getElementById("fc_frame");
        if (fcFrame) {
          if (checkFcDnClass()) {
            clearInterval(intervalRef.current);
          }
        }
      }, 500);
    };
    chatScript.setAttribute("chat", "true");
    document.body.appendChild(chatScript);
    return function () {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      document.head.removeChild(script);
      document.body.removeChild(chatScript);
    };
  }, []);
}